const i18n = (data, id, language=`en`) => {
  const lang = language
  const currentLanguageObj = data[lang] ? data[lang] : data[`en`]
  return currentLanguageObj[id]
}

export const getLocationLanguage = () => {
  if (typeof window === `undefined`) return 'en'
  const isLanguage = (str) => require('../components/languages.json').find(item => item === str)?.length > 0
  const lang = window.location.pathname.split(`/`).map(item => {
    if (isLanguage(item)) return item
    else return undefined
  }).filter(item => item !== undefined)[0]
  return lang
}

export const getLocationWithoutLang = () => {
  if (typeof window === `undefined`) return `/`
  const langs = require('../components/languages.json')
  const isLanguage = (str) => langs.find(item => item === str)?.length > 0
  return window.location.pathname.split(`/`).map(item => {
    if (!isLanguage(item) && item.length > 0) return item
    else return undefined
  }).filter(item => item !== undefined).join('/')
}

export default i18n

